const angular = require('angular');
const {isFunction, isObject} = angular;

$rootScopeExtensions.$inject = [
  '$provide',
];

export function $rootScopeExtensions($provide) {
  $provide.decorator('$rootScope', ['$delegate', function ($delegate) {

    Object.defineProperties($delegate.constructor.prototype, {
      '$subscribeOnScope': {
        value: function (observable, subscriber) {
          var subscription;
          if (isFunction(subscriber))
            subscription = observable.subscribe(subscriber);
          else if (isObject(subscriber))
            subscription = observable.subscribe(subscriber.next, subscriber.error, subscriber.complete);
          else
            throw new Error('$subscribeOnScope expects a Function or a Subscription');
          this.$on('$destroy', () => {
            subscription.unsubscribe();
          });
        },
        enumerable: false,
        configurable: true,
        writable: true
      }
    });

    return $delegate;
  }]);
}



// WEBPACK FOOTER //
// ./src/js/core-utilities/angular-rx-attrs/$rootScopeExtensions.js